import * as color from '@constant/color';

// 어드민 마케팅 지표 구간별 상태 라벨/색상 임계값
// - 모바일 학습 앱 업계 벤치마크를 참고한 휴리스틱
// - 분모(target)가 0이면 'N/A' 반환
// - 임계값은 "이상" 기준 (>=)

export type TMetricStatus = '우수' | '양호' | '보통' | '미흡' | 'N/A';

interface IThreshold {
  excellent: number;
  good: number;
  fair: number;
}

const STATUS_COLOR_MAP: Record<TMetricStatus, string> = {
  우수: color.GREEN_3,
  양호: color.GREEN_4,
  보통: color.YELLOW_1,
  미흡: color.RED_2,
  'N/A': color.GRAY_2,
};

// 단위는 % (0~100). 예: ACTIVE_RATE.excellent = 30 → 30% 이상이면 '우수'
const ACTIVE_RATE: IThreshold = { excellent: 30, good: 20, fair: 10 };
const LIR_RATE: IThreshold = { excellent: 40, good: 25, fair: 15 };
const D1_RATE: IThreshold = { excellent: 40, good: 25, fair: 15 };
const D7_RATE: IThreshold = { excellent: 20, good: 10, fair: 5 };
const W1_RATE: IThreshold = { excellent: 25, good: 15, fair: 8 };

const judgeRate = (percentage: number, threshold: IThreshold): TMetricStatus => {
  if (percentage >= threshold.excellent) return '우수';
  if (percentage >= threshold.good) return '양호';
  if (percentage >= threshold.fair) return '보통';
  return '미흡';
};

const judgeFromCount = (
  achieved: number,
  target: number,
  threshold: IThreshold,
): TMetricStatus => {
  if (!target) return 'N/A';
  const percentage = (achieved / target) * 100;
  return judgeRate(percentage, threshold);
};

export const judgeActiveStatus = (active: number, total: number): TMetricStatus =>
  judgeFromCount(active, total, ACTIVE_RATE);

export const judgeLirStatus = (achieved: number, target: number): TMetricStatus =>
  judgeFromCount(achieved, target, LIR_RATE);

export const judgeD1Status = (retained: number, target: number): TMetricStatus =>
  judgeFromCount(retained, target, D1_RATE);

export const judgeD7Status = (retained: number, target: number): TMetricStatus =>
  judgeFromCount(retained, target, D7_RATE);

export const judgeW1Status = (retained: number, target: number): TMetricStatus =>
  judgeFromCount(retained, target, W1_RATE);

export const getMetricStatusColor = (status: TMetricStatus): string => STATUS_COLOR_MAP[status];